/* React */
import React from "react";

/* Hooks */
import { useEffectiveShowNoValueEntries } from "src/utils/hooks/useEffectiveShowNoValueEntries";

/* Ionic */
import { IonIcon } from "@ionic/react";
import { person } from "ionicons/icons";

/* Stylesheet */
import styles from "./ChartLabel.module.scss";

/* Interfaces */
import { ChartLabelProps } from "src/shared/interfaces/charts/ChartLabel";

const ChartLabel: React.FC<ChartLabelProps> = (
  label: ChartLabelProps
) => {
  // Gated by custom-cohort state so a stale toggle can't inflate the numerator
  // for custom-cohort views - see the hook's docs.
  const showNoValueEntries = useEffectiveShowNoValueEntries();

  // `totalCohortSize` / `lookedForNoValueTotal` are only populated for
  // descriptive statistics - other chart types (survival analysis, treatment
  // patterns) fall back to plain `total`, matching their previous behavior.
  const numerator =
    showNoValueEntries && label.lookedForNoValueTotal !== undefined
      ? (label.total ?? 0) + label.lookedForNoValueTotal
      : label.total;

  // The no-value completeness states are no longer shown as a text footnote:
  // both "Looked for, no value" and "Not looked for" are surfaced as their own
  // terminal sankey nodes (recovered by the backend when the sankey's
  // "show no-value states" option is on) and as the grey categories in
  // descriptive statistics. A separate "X not looked for" annotation would
  // only duplicate those patients.
  return (
    <div className={styles.chart_label}>
      <IonIcon className={styles.icon} icon={person} />
      <div className={styles.total_container}>
        <div className={styles.label}>Patients</div>
        <div className={styles.total}>{numerator}</div>
        {label.totalCohortSize !== undefined ? (
          <div className={styles.overall}>
            (of {label.totalCohortSize})
          </div>
        ) : undefined}
      </div>
      <div className={styles.feature_or_cohort}>
        {label.label}
      </div>
    </div>
  );
};

export default ChartLabel;
